module.exports = __webpack_public_path__ + "static/media/wrinkles_nasolabial.187dbf0c.svg";